import {useEffect, useState, useContext, useRef, useCallback} from 'react';
import {Modal, Image} from 'react-bootstrap';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import './profileImage.css';
import profileImgPlaceHolder from 'images/svg/default-user.svg';
import CameraIcon from 'images/svg/Group 36888.svg';
import Upload from 'images/svg/upload.svg';
import ProfileEdit from 'images/svg/Profile-pencil.svg';
import EmpProfile from 'images/svg/users-default.svg';
import classNames from './my-profile.module.css';
import {AuthContext} from 'contexts/auth.context';
import {useTranslation} from 'react-i18next';
import Styles from './job-board-menu.module.css';

const pixelRatio = 4;

const ProfilePicture = (props) => {
  const {t} = useTranslation();
  const [imagePath, setImagePath] = useState('');
  const [imgIcon, setimgIcon] = useState('');
  const [profilePicUpload, setProfilePicUpload] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [upImg, setUpImg] = useState();
  const authProvider = useContext(AuthContext);
  const profileDetails = authProvider.profileSettings;
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({unit: '%', width: 30, aspect: 16 / 16});
  const [completedCrop, setCompletedCrop] = useState(null);
  const [imagetype, setImageType] = useState('');

  const imgRef = useRef(null);

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingEnabled = false;

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );
  }, [completedCrop]);

  useEffect(() => {
    if (props.profilePic) {
      setImagePath(props.profilePic);
      setimgIcon(ProfileEdit);
    } else {
      setImagePath(profileImgPlaceHolder);
      setimgIcon(Upload);
    }
  }, [props.profilePic]);

  const handleFileClear = (event) => {
    if (event) event.preventDefault();
    // const canvas = previewCanvasRef.current;
    // const ctx = canvas.getContext('2d');
    // ctx.clearRect(0, 0, canvas.width, canvas.height);
    document.getElementById('file-input').value = '';
    previewCanvasRef.current = null;
    setUpImg(null);
    setProfilePicUpload(false);
    setSelectedFileName('');
    imgRef.current = null;
    setImageType('');
    setCompletedCrop(null);
  };

  const handleFile = async (event) => {
    event.preventDefault();
    const canvasRef = previewCanvasRef.current;
    const imageData64 = canvasRef.toDataURL(imagetype);
    setImagePath(imageData64);
    props.submitProfileImage({
      imageData64: imageData64,
      selectedFileName: selectedFileName,
    });
    setProfilePicUpload(false);
  };

  const onSelectFile = (e) => {
    const files = e.target.files;
    setImageType(files[0].type);
    setProfilePicUpload(true);
    if (files && files.length > 0) {
      setSelectedFileName(files[0].name);
      const reader = new FileReader();
      reader.addEventListener('load', () => setUpImg(reader.result));
      reader.readAsDataURL(files[0]);
    }
  };

  return (
    <div>
      <div className="justify-space-between d-flex">
        <div>
          {!props.upload_profile_image ? (
            <div className="position-relative d-flex justify-content-center align-items-center">
              <div className={Styles['profile-image-div']}>
                <Image
                  className={Styles['profile-image']}
                  onError={() => setImagePath(profileImgPlaceHolder)}
                  src={imagePath ? imagePath : profileImgPlaceHolder}
                ></Image>
              </div>
              <div className={Styles['profile-image-upload']}>
                <label htmlFor="file-input">
                  <div>
                    {props.module == 'profile' ? (
                      <img
                        className={Styles['profile-image-upload-icon']}
                        src={CameraIcon}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </label>
                <input
                  type="file"
                  style={{display: 'none'}}
                  id="file-input"
                  accept=".png, .jpg, .jpeg"
                  onChange={(e) => onSelectFile(e)}
                  multiple={false}
                />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <Modal
        className={'awl-modal ' + classNames['create-group-modal']}
        show={profilePicUpload}
        onHide={(e) => handleFileClear(e)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="title-modal">{t('Profile_Upload_Profile Image')}</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="awl-custom-scroll">
          <ReactCrop
            src={upImg}
            onImageLoaded={onLoad}
            crop={crop}
            onChange={(c) => setCrop(c)}
            onComplete={(c) => setCompletedCrop(c)}
          />
          {(upImg || []).length ? (
            <>
              <div style={{textAlign: 'center', display: 'none'}}>
                <canvas
                  ref={previewCanvasRef}
                  style={{
                    width: completedCrop?.width ?? 0,
                    height: completedCrop?.height ?? 0,
                  }}
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </Modal.Body>
        <Modal.Footer>
          {' '}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <button
              type="button"
              onClick={(e) => handleFileClear(e)}
              className="btn btn-secondary"
              tabIndex="16"
              style={{marginRight: '.5rem'}}
            >
              {imgIcon === ProfileEdit
                ? t('PROFILE_UPLOAD_Remove')
                : t('Cancel')}
            </button>
            <button
              type="button"
              disabled={!completedCrop?.width || !completedCrop?.height}
              onClick={(e) => handleFile(e)}
              className="btn btn-primary"
              tabIndex="16"
            >
              {imgIcon === ProfileEdit
                ? t('Profile_Upload Now')
                : t('Profile_Upload')}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProfilePicture;
